import { homeApi } from "@/api/template";
const state = {
  templateList: [],
  templateArrIfo: [],
  homeList: [],
  likeList: [],
  editType: '',
  sliderList: [],
  iconList: [], // 图标
  coupon: {}, // 新人优惠券
  liveObj: {
    title: '', // 标题
    titleColor: '', // 标题颜色
    showModule: '1', // 所有涉及布尔值的字段 0 = false(隐藏);1 = true（显示）
    list: [
      {
        image: '', // 图片地址
        linkType: 1, // 链接类型
        linkValue: '', // 链接地址
      }
    ]
  },
  collageObj: {
    // 拼团模块
    pinModule: {
      title: '', // 标题
      titleColor: '', // 标题颜色
      subtitle: '', // 副标题
      subtitleColor: '', // 副标题颜色
      linkType: 1, // 链接类型
      linkValue: '', // 链接地址
      items: [], // 拼团商品list数据
    },
    // 大牌推荐模块
    bigModule: {
      title: '', // 标题
      titleColor: '', // 标题颜色
      subtitle: '', // 副标题
      subtitleColor: '', // 副标题颜色
      leftImgObj: {
        image: '', // 图片地址
        linkType: 1, // 链接类型
        linkValue: '', // 链接地址
        words: '', // 文案
      },
      rightImgObj: {
        image: '', // 图片地址
        linkType: 1, // 链接类型
        linkValue: '', // 链接地址
        words: '', // 文案
      }
    },
    newModule: {
      title: '', // 标题
      titleColor: '', // 标题颜色
      subtitle: '', // 副标题
      subtitleColor: '', // 副标题颜色
      linkType: 1, // 链接类型
      linkValue: '', // 链接地址
      items: [], // 商品list数据
    },
    baoModule: {
      title: '', // 标题
      titleColor: '', // 标题颜色
      subtitle: '', // 副标题
      subtitleColor: '', // 副标题颜色
      linkType: 1, // 链接类型
      linkValue: '', // 链接地址
      items: [], // 商品list数据
    }
  },
  qualityObj: {
    title: '', // 标题
    titleColor: '', // 标题颜色
    linkType: 1, // 链接类型
    linkValue: '', // 链接地址
    list: []
  }

};
const getters = {
  templateList: state => state.templateList,
  templateArrIfo: state => state.templateArrIfo,
  silder: state => state.templateArrIfo[0],
  homeList: state => state.homeList,
  likeList: state => state.likeList,
  editType: state => state.editType,
  sliderList: state => state.sliderList,
  iconList: state => state.iconList,
  liveObj: state => state.liveObj,
  collageObj: state => state.collageObj,
  qualityObj: state => state.qualityObj,
  coupon: state => state.coupon,




};
const actions = {
  getTemplateList({ commit, state, rootState }, id) {
    homeApi.getHomeModule(id).then(res => {
      commit("getList", res);
      let list = res.data;
      let listLen = list.length;
      let arr = [];
      let ids = [];
      for (let i = 0; i < listLen; i++) {
        let data = {
          id: list[i].id,
          decType: list[i].decType,
          infoId: list[i].infoId,
          detail: []
        };
        ids.push(list[i].id);
        homeApi.getHomeModuleInfo([list[i].id]).then(res => {
          data.detail = res.data;
          // console.log(data);
          commit("getModuleIfo", data);
        });
      }
    });
  },
  getHomeList({ commit, state }) {
    homeApi.appHomePage("956479901225881602").then(res => {
      return new Promise((resolve, reject) => {
        commit("homeList", res.data);
        resolve(state.homeList);
      });
      console.log(res);
      // commit("homeList", res.data);
    });
  },
  clearCache({ commit, state }) {
    homeApi.clearCache().then(res => { });
  }
};

const mutations = {
  getList(state, res) {
    state.templateList = res.data;
    console.log(res.data);
  },
  getModuleIfo(state, data) {
    state.templateArrIfo.push(data);
  },

  homeList(state, res) {
    state.homeList = res;
    // state.likeList = res[10].appTitleGoodsDto.titleItemDetail;
  },
  delLikeList(state, index) {
    // state.likeList.splice(index, 1);
  },
  getLikeList(state) {
    state.likeList = state.homeList[10];
  },
  setEditType(state, param) {
    state.editType = param;
  },
  setSliderList(state, param) {
    state.sliderList = param;
  },
  setIconList(state, param) {
    state.iconList = param;
  },
  setLiveObj(state, param) {
    state.liveObj = param;
  },
  setCollageObj(state, param) {
    state.collageObj = param;
  },
  setQualityObj(state, param) {
    state.qualityObj = param;
  },
  setCoupon(state, param) {
    state.coupon = param;
  }
};

export default {
  state,
  actions,
  getters,
  mutations
};
